
import { Link } from 'react-router-dom';

export default function ProductCTA() {
  return (
    <section className="py-16 bg-gradient-to-r from-red-600 to-red-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center text-white">
          <h2 className="text-3xl font-bold mb-4">Ready to Enhance Your Fire Safety?</h2>
          <p className="text-xl text-red-100 mb-8 max-w-3xl mx-auto">
            Get professional consultation and competitive quotes for manual call points and complete fire alarm systems
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link
              to="/contact"
              className="bg-white text-red-600 hover:bg-gray-100 px-8 py-4 rounded-lg font-semibold transition-colors whitespace-nowrap"
            >
              <i className="ri-mail-line mr-2"></i>
              Request Quote
            </Link>
            <a
              href="tel:+97455544093"
              className="border-2 border-white text-white hover:bg-white hover:text-red-600 px-8 py-4 rounded-lg font-semibold transition-colors whitespace-nowrap"
            >
              <i className="ri-phone-line mr-2"></i>
              Call +974 5554 4093
            </a>
          </div>

          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-customer-service-line text-2xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">Expert Consultation</h3>
              <p className="text-red-100 text-sm">Professional guidance for your fire safety needs</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-tools-line text-2xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">Professional Installation</h3>
              <p className="text-red-100 text-sm">Certified technicians ensure proper setup</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-2xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">QCDD Compliance</h3>
              <p className="text-red-100 text-sm">All products meet Qatar safety standards</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
